import axios from 'axios'
import { useAuthStore } from '@/stores/auth'

const api = axios.create({
  baseURL: import.meta.env.VITE_REQUEST_URL,
  withCredentials: true,
})

// Add a request interceptor
api.interceptors.request.use(
  config => {
    const auth = useAuthStore()
    if (auth.accessToken) {
      config.headers['Authorization'] = auth.accessToken // No 'Bearer'
    }
    return config
  },
  error => Promise.reject(error)
)

// Add a response interceptor
api.interceptors.response.use(
  response => response,
  async error => {
    const auth = useAuthStore()
    const originalRequest = error.config

    if (
      error.response &&
      error.response.status === 401 &&
      auth.refreshToken &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true
      try {
        const res = await api.post('/auth/refresh', { refreshToken: auth.refreshToken })
        // Immediately update both tokens
        auth.accessToken = res.data.accessToken
        localStorage.setItem('accessToken', res.data.accessToken)
        if (res.data.refreshToken) {
          auth.refreshToken = res.data.refreshToken
          localStorage.setItem('refreshToken', res.data.refreshToken)
        }
        // Make sure the next request uses the new refresh token
        api.defaults.headers.common['Authorization'] = auth.accessToken
        originalRequest.headers['Authorization'] = auth.accessToken
        return api(originalRequest)
      } catch (refreshError) {
        auth.logout()
        window.location.href = '/login'
        return Promise.reject(refreshError)
      }
    }
    return Promise.reject(error)
  }
)

export default api